import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const SEOHead = ({ 
  title = "SlazySloth - AI-Powered Tech Interview Practice | DSA, System Design & More",
  description = "Master DSA, System Design (LLD/HLD), and Core CS subjects with AI-powered feedback. Practice coding interviews, get personalized guidance, and ace your tech interviews with confidence.",
  keywords = "tech interview practice, DSA practice, system design, coding interview, AI feedback, LLD, HLD, data structures, algorithms, computer science, interview preparation",
  image = "/images/dashboard.png",
  url = "https://slazysloth.com/",
  type = "website",
  structuredData = null
}) => {
  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "SlazySloth",
    "alternateName": "SlazySloth - AI-Powered Tech Interview Practice",
    "url": url,
    "description": description,
    "applicationCategory": "EducationalApplication",
    "operatingSystem": "Web Browser",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "creator": {
      "@type": "Organization",
      "name": "SlazySloth",
      "url": "https://slazysloth.com"
    },
    "featureList": [
      "DSA Practice with AI Feedback",
      "System Design (LLD/HLD) Practice",
      "Core Computer Science Subjects",
      "AI-Powered Interview Simulation",
      "Personalized Learning Path",
      "Progress Tracking"
    ],
    "screenshot": image
  };

  const finalStructuredData = structuredData || defaultStructuredData;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="SlazySloth" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="SlazySloth" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(finalStructuredData)}
      </script>
    </Helmet>
  );
};

// Higher-order component to wrap pages with HelmetProvider
export const withSEO = (Component) => {
  return function SEOWrappedComponent(props) {
    return (
      <HelmetProvider>
        <Component {...props} />
      </HelmetProvider>
    );
  };
};

export default SEOHead;
